import { useQuery } from '@tanstack/react-query';

import { queryFn } from './portfolioAnalysisQueryFn';

export const QUERY_KEY = 'PORTFOLIO_ANALYSIS';

export function usePortfolioAnalysis(id: string) {
  const { data, status } = useQuery({
    queryKey: [QUERY_KEY, id],
    queryFn: async () => queryFn(id),
    retry: 1,
  });

  return {
    data,
    status,
  };
}
